<template>
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 1.5a13.5 13.5 0 1 0 0 27 13.5 13.5 0 0 0 0-27Zm-2.27 2.22A11.5 11.5 0 0 0 3.54 14h5.5c.26-3.7 1.54-7.26 3.69-10.28Zm4.54 0A20.13 20.13 0 0 1 20.96 14h5.5a11.5 11.5 0 0 0-9.19-10.28ZM18.95 14A18.13 18.13 0 0 0 15 4.04 18.13 18.13 0 0 0 11.05 14h7.9Zm-7.9 2h7.9A18.13 18.13 0 0 1 15 25.96 18.13 18.13 0 0 1 11.05 16Zm-2 0h-5.5a11.5 11.5 0 0 0 9.18 10.28A20.13 20.13 0 0 1 9.04 16Zm8.22 10.28A20.13 20.13 0 0 0 20.96 16h5.5a11.5 11.5 0 0 1-9.19 10.28Z"
      fill="currentColor"
    />
  </svg>
</template>
